<script setup>
  import { storeToRefs } from "pinia";
  import TwoPanePage from "@/templates/TwoPanePage.vue";
  import { ListContainer } from "@/components/episto-ui/list";
  import { ListItem } from "@/components/episto-ui/list";
  import TargetCard from "@/components/Survey/Targets/TargetCard.vue";
  import TargetQuotasCard from "@/components/Survey/Targets/TargetQuotasCard.vue";
  import { getFlagByCountryCode } from "@utils/constants/regions";
  import { useSurveyTargetsStore } from "@stores/survey/surveyTargets";

  const surveyTargetsStore = useSurveyTargetsStore();
  const { currentTargets, selectedTarget, hasSingleTarget } = storeToRefs(surveyTargetsStore);
  const { addNewTarget, duplicateTarget, updateSelectedTarget, removeTarget, isTargetSelected } = surveyTargetsStore;

  const formatNumber = (value) => value.toLocaleString("en-US");
</script>

<template>
  <TwoPanePage
    data-cy="survey-targets-page"
    :span-right="6">
    <template #left>
      <ListContainer
        element-name="Target"
        :add-element="addNewTarget"
        :show-header="false">
        <template #elements>
          <ListItem
            v-for="(target, index) in currentTargets"
            :key="target.token"
            :index="index"
            :element-title="target.name || 'Untitled'"
            :select-element="() => updateSelectedTarget(target.token)"
            :is-element-selected="() => isTargetSelected(target.token)"
            :duplicate-element="() => duplicateTarget(target.token)"
            :delete-element="hasSingleTarget ? null : () => removeTarget(target.token)"
            confirm-deletion>
            <template
              v-if="target.countries?.length || target.target > 0 || target.cpi > 0"
              #additional-content>
              <div class="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-muted-foreground">
                <span
                  v-if="target.countries?.length"
                  class="flex gap-1">
                  <span
                    v-for="code in target.countries"
                    :key="code">{{ getFlagByCountryCode(code) }}</span>
                </span>
                <span v-if="target.target > 0">N: {{ formatNumber(target.target) }}</span>
                <span v-if="target.cpi > 0">CPI: {{ target.cpi }}</span>
              </div>
            </template>
          </ListItem>
        </template>
      </ListContainer>
    </template>

    <template #right>
      <div
        v-if="selectedTarget?.token"
        class="space-y-4">
        <TargetCard />
        <TargetQuotasCard />
      </div>
      <div
        v-else
        class="flex h-48 items-center justify-center text-sm text-muted-foreground">
        Select a target to edit
      </div>
    </template>
  </TwoPanePage>
</template>
